import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-l-alarm",
  "use": "icon-l-alarm-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-l-alarm\"><path d=\"M512 206.144l396.992 687.552L115.008 893.696 512 206.144M512 70.912 0 957.696l1024 0L512 70.912 512 70.912 512 70.912zM512 66.304M480 381.696l64 0 0 320-64 0L480 381.696 480 381.696zM544 765.696l0 64-64 0 0-64M480 765.696\" fill=\"#ffffff\" p-id=\"3075\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol